import { Button } from '../action/Button'
import { Modal } from '../action/Modal'

export const NGWordModal: React.FC<{
  isOpen: boolean
  setIsOpen: (v: boolean) => void
}> = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      title={'NGワードが含まれています'}
      actionButtons={
        <div className="grid grid-cols-1 mt-8 mx-4 gap-x-4">
          <div className="mb-8 text-sm text-gray-700">
            本文にNGワードが含まれていますので修正をしてください。
          </div>
          <Button
            type="button"
            variant="primary"
            shrink
            onClick={async () => {
              props.setIsOpen(false)
            }}
          >
            OK
          </Button>
        </div>
      }
    />
  )
}
